import { Stack, Typography } from '@mui/material';

import { IconButton } from '@/components/form/baseInputs/Button/IconButton';
import { XCloseIcon } from '@/components/icons/XCloseIcon';
import { PILL } from '@/styles/tokens/borderRadii';
import { COLORS } from '@/styles/tokens/colors';

export interface SelectedTemplateProps {
  onRemove: () => void;
  title: string;
}

/** The template attached to the next creation request. */
export function SelectedTemplate({ onRemove, title }: SelectedTemplateProps) {
  return (
    <Stack direction="row" alignItems="center" gap={1} minWidth={0}>
      <Typography
        variant="body-xs"
        sx={{ color: COLORS.TEXT.SECONDARY, flexShrink: 0 }}
      >
        Template
      </Typography>
      <Stack
        direction="row"
        alignItems="center"
        gap={0.5}
        sx={{
          height: 24,
          minWidth: 0,
          pl: 1,
          pr: 0.25,
          bgcolor: COLORS.BLUE[100],
          border: `1px solid ${COLORS.BLUE[200]}`,
          borderRadius: PILL,
        }}
      >
        <Typography
          variant="body-xs"
          noWrap
          sx={{ color: COLORS.TEXT.PRIMARY }}
        >
          {title}
        </Typography>
        <IconButton
          icon={XCloseIcon}
          ariaLabel={`Remove ${title} template`}
          variant="transparent"
          size="xs"
          sx={{
            width: 18,
            height: 18,
            p: 0,
            borderRadius: PILL,
            '&:hover': {
              bgcolor: 'transparent',
              borderColor: 'transparent',
            },
          }}
          onClick={onRemove}
        />
      </Stack>
    </Stack>
  );
}
